import React from 'react';
import './fonevideo.scss';

class FoneVideo extends React.Component {
  constructor(props) {
    super(props);
    this.itemIndex = 0;
    this.vPlayer = null;
  };

  componentDidMount() {
    this.initVideo();
    this.vPlayer.play();
  };

  initVideo = () => {
    this.vPlayer.preload = 'auto';
    this.vPlayer.muted = 'muted';
    this.vPlayer.autoplay = 'autoplay';
    this.vPlayer.loop = 'loop';
  };

  render() {
    return (
      <section className='video-fon'>
        <div className='video-fon-fone' />
        <div id='video-bg'>
          <video ref={(video) => {this.vPlayer = video;}} id='video-1' >
            <source src='../../media/1.mp4' type='video/mp4' />
          </video>
        </div>
      </section>
    );
  };
};


export default FoneVideo;



// WEBPACK FOOTER //
// ./src/client/components/fonevideo/fonevideo.jsx